import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getCategoriasTextos(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("categoriasTextos/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
/*    getUnidadesBox(context, filtros) {
        filtros.componente = "SearchBoxUnidade";
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("unidades/access/listaBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
      },*/
    getCategoriaTextoBox(context, filtros) {
        filtros.componente = "SearchBoxDefault";
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("categoriasTextos/access/listaBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getCategoriasTextoWeb() {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("categoriasTextos/access/listaWeb").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getCategoriaTexto(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("categoriasTextos/access/obter", {ID_TEXTO_CATEGORIA: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deleteCategoriaTexto(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("categoriasTextos/access/excluir", {ID_TEXTO_CATEGORIA: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postCategoriaTexto(context, categoriaTexto) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("categoriasTextos/access/salvar", categoriaTexto).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};